import React, { type FC } from 'react'

import type { ReadonlyRecord } from '../../../utils'

import { type CybusServer, type CybusService, selectNodesPage, type StatusType, Translation } from '../../../domain'

import { Status } from '../common'
import { useTranslator } from '../Internationalization'
import { ResourcesTable } from '../Resources'

export const Table: FC<Readonly<{ serviceId: CybusService['id'] } | { serverId: CybusServer['id'] } | ReadonlyRecord<string, never>>> = (filter) => {
    const translator = useTranslator()

    const customCellRender = (status: StatusType): JSX.Element => <Status status={status} />

    return (
        <ResourcesTable
            subscriptionUsecase="manageNodesUsecase"
            filter={{
                ...('serviceId' in filter && { service: filter.serviceId }),
                ...('serverId' in filter && { server: filter.serverId }),
            }}
            data={selectNodesPage}
            dataTableMapper={(nodes) => nodes}
            columns={{
                ...('serviceId' in filter ? {} : { service: { label: Translation.SERVICE_ID, sort: true } }),
                name: { label: Translation.NAME, sort: true },
                parent: { label: Translation.PARENT, sort: true },
                protocol: { label: translator.formatTranslation(Translation.PROTOCOL, { count: 1 }), sort: true },
                operation: { label: translator.formatTranslation(Translation.OPERATION, { count: 1 }) },
                status: { label: Translation.STATUS, customCellRender },
            }}
            translations={{ emptyTable: Translation.NO_NODES_AVAILABLE }}
        />
    )
}
